/**
 * Brand atoms usable INSIDE the ui kit (no @/ui imports — avoids cycles).
 * Geometry: BRAND-GUIDELINES §1, viewBox 0 0 50 58, View-built (OTA-safe).
 */
import React from 'react';
import { Text, View } from 'react-native';

import { useTheme } from '@/theme';

export function BeroMark({ height = 24 }: { height?: number }) {
  const { colors } = useTheme();
  const u = height / 58;
  return (
    <View style={{ width: 50 * u, height }}>
      <View
        style={{
          position: 'absolute', left: 2 * u, top: 1 * u, width: 46 * u, height: 55 * u,
          borderWidth: 9 * u, borderBottomWidth: 0, borderColor: colors.primary500,
          borderTopLeftRadius: 23 * u, borderTopRightRadius: 23 * u,
        }}
      />
      <View style={{ position: 'absolute', left: 19 * u, top: 24 * u, width: 12 * u, height: 12 * u, borderRadius: 6 * u, backgroundColor: colors.accent500 }} />
      <View style={{ position: 'absolute', left: 20 * u, top: 40 * u, width: 10 * u, height: 16 * u, borderRadius: 5 * u, backgroundColor: colors.accent500 }} />
    </View>
  );
}

export function Wordmark({ size = 20 }: { size?: number }) {
  const { colors } = useTheme();
  return (
    <Text style={{ fontFamily: 'Sora_800ExtraBold', fontSize: size, lineHeight: size * 1.25, letterSpacing: -size * 0.04, color: colors.textPrimary }}>
      bero
    </Text>
  );
}

export function BrandLockup({ markHeight = 26, wordSize, gap }: { markHeight?: number; wordSize?: number; gap?: number }) {
  // Official full-logo proportions (brand/bero-brand/logos/*.svg, viewBox 180x60):
  // wordmark = 0.76 x mark height, gap = 0.19 x mark height. Derived here so every
  // screen renders the SAME lockup — pass overrides only with a design reason.
  const word = wordSize ?? Math.round(markHeight * 0.76);
  const g = gap ?? Math.max(6, Math.round(markHeight * 0.19));
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: g }}>
      <BeroMark height={markHeight} />
      <Wordmark size={word} />
    </View>
  );
}
